export default __webpack_public_path__ + "static/media/Strangler's Tunic of the Black Arts.133df602.jpg";